'use strict';


export default function($parse) {
	'ngInject';

	return {
		controller: controller,
		controllerAs: '$query',
		link: postLink,
		scope: true,
	}

	function postLink(scope, element, attrs, $query) {
		if (attrs.hasOwnProperty('cache')) {
			$query.cache = scope.$eval(attrs.cache);
		}
		$query.pageParamName = attrs.pageParamName || 'page';
		$query.params = $parse(attrs.initialParams)(scope) || {};
		if (attrs.onLoad) {
			$query.onLoad = attrs.onLoad;
		}
		$query.query(attrs.url);
	}

	function controller($scope, $log, $http, toastr) {
		'ngInject';

		var vm = this;

		vm.updateParams = function(params) {
			vm.params = angular.merge(vm.params, params);
		}

		vm.query = function(url) {
			const params = angular.copy(vm.params);
			if (url !== vm.nextUrl && url !== vm.previousUrl && params) {
				const urlObj = new URL(url, window.location.origin);
				Object.keys(params).forEach(key => {
					if (params[key] === undefined || params[key] === null) {
						urlObj.searchParams.delete(key);
					} else {
						urlObj.searchParams.set(key, params[key]);
					}
				});
				url = urlObj.pathname + urlObj.search;
			}
			vm.url = url;
			vm.loading = true;
			vm.appliedParams = params;

			function querySuccess(response) {
				if (Array.isArray(response.data)) {
					vm.count = response.data.length;
					vm.results = response.data;
					vm.paginated = false;
					vm.current = 1;
					vm.total = 1;
				} else {
					vm.count = response.data.count;
					vm.results = response.data.results;
					vm.paginated = true;
					vm.previousUrl = response.data.previous;
					vm.nextUrl = response.data.next;
					try {
						// nosemgrep
						var currentRegex = new RegExp(`${vm.pageParamName}=([0-9]+)`);
						vm.current = parseInt(url.match(currentRegex)[1]);
					} catch(e) {
						vm.current = 1;
					}
					vm.total = vm.nextUrl ? Math.ceil(vm.count/vm.results.length) : vm.current;
				}
				vm.params.page = vm.current;
				if (vm.onLoad) {
					$scope.$eval(vm.onLoad);
				}
			}

			function queryError(e) {
				$log.error(e);
				if (e.status === 429) {
					toastr.warning("Too many requests.  Please try again later.");
				} else if (e.status >= 500) {
					toastr.error("Failed to fetch data.  Please try again later.")
				}
			}

			$http.get(url, {cache: vm.cache}).then(querySuccess, queryError).finally(() => {
				vm.loading = false;
			});
		};

		vm.reload = function() {
			vm.query(vm.url);
		}

		vm.conditionalReload = function(params) {
			let paramsAreUpdates = params.page === vm.current;
			for (const key in params) {
				if (key === 'page') {
					continue;
				}
				if (vm.appliedParams[key] !== params[key]) {
					paramsAreUpdates = false;
					break;
				}
			}
			if (!paramsAreUpdates) {
				vm.updateParams(params);
				vm.reload();
			}
		}

	}
}